/**
 * RegistrationMagic's reCAPTCHA v3 integration requests a token once, on page
 * load. Google expires v3 tokens after two minutes, so a sign-up that takes
 * longer than that is rejected with "The reCAPTCHA response provided was
 * incorrect". Keep the token fresh for as long as the form is open.
 */
(function() {
    'use strict';

    // Comfortably inside Google's two-minute token lifetime.
    const REFRESH_MS = 90 * 1000;

    /**
     * RM's v3 loader is api.js?onload=rmInitCaptcha&render=<site key>; its v2
     * loader uses rmInitCaptchaV2 with render=explicit and needs no refresh.
     */
    function getSiteKey() {
        const script = document.querySelector('script[src*="recaptcha/api.js"][src*="onload=rmInitCaptcha&"]');
        if (!script) {
            return null;
        }
        const key = new URL(script.src, window.location.href).searchParams.get('render');
        return key && key !== 'explicit' ? key : null;
    }

    function refreshToken() {
        const fields = document.querySelectorAll('input.g-recaptcha-response');
        const siteKey = getSiteKey();
        if (!fields.length || !siteKey || typeof grecaptcha === 'undefined') {
            return;
        }
        grecaptcha.ready(function() {
            grecaptcha.execute(siteKey, { action: 'submit' }).then(function(token) {
                fields.forEach(function(field) {
                    field.value = token;
                });
            });
        });
    }

    setInterval(refreshToken, REFRESH_MS);

    // Background tabs throttle timers, so the token can be stale when the user
    // comes back to the form.
    document.addEventListener('visibilitychange', function() {
        if (document.visibilityState === 'visible') {
            refreshToken();
        }
    });
})();
